import { render, staticRenderFns } from "./sms-segment-calculator.vue?vue&type=template&id=366f1fc2&scoped=true"
import script from "./sms-segment-calculator.vue?vue&type=script&lang=js"
export * from "./sms-segment-calculator.vue?vue&type=script&lang=js"
import style0 from "./sms-segment-calculator.vue?vue&type=style&index=0&id=366f1fc2&prod&scoped=true&lang=css"
import style1 from "./sms-segment-calculator.vue?vue&type=style&index=1&id=366f1fc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366f1fc2",
  null
  
)

export default component.exports